import { render, staticRenderFns } from "./DespachoResumenProducto.vue?vue&type=template&id=a48d7f1a&"
import script from "./DespachoResumenProducto.vue?vue&type=script&lang=js&"
export * from "./DespachoResumenProducto.vue?vue&type=script&lang=js&"
import style0 from "./DespachoResumenProducto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports